import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], totalCount:0 ,totalAmount:0, error: "", message: "" }



export const dateWisePartnerRevenueAction = createAsyncThunk(
    'date-wise-partner-revenue',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.get(`/admins/api/date-wise-partner-revenue?partnerId=${data?.partnerId}&publisherId=${data?.publisher_id}&startDate=${data?.startDate}&endDate=${data?.endDate}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const dateWisePartnerRevenueSlice = createSlice({
    name: 'date-wise-partner-revenue',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(dateWisePartnerRevenueAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(dateWisePartnerRevenueAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalAmount = action?.payload?.totalAmount
                state.totalCount = action?.payload?.totalCount
            })
            builder.addCase(dateWisePartnerRevenueAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalAmount = action?.payload?.totalAmount
                state.totalCount = action?.payload?.totalCount
            })
        },

})



export const dateWisePartnerRevenueReducer = dateWisePartnerRevenueSlice.reducer